export const ENUM__i18n_namespace = {
  PAGE_AUTH: 'page_auth',
  PAGE_SETTINGS_USER: 'page_settings_user',
  PAGE_SETTINGS_WORKSPACE: 'page_settings_workspace',
  PAGE_GENERATION: 'page_generation',
  PAGE_SEARCH: 'page_search',
  PAGE_DIFFUSION_MODELS: 'page_diffusion_models',
  PAGE_COLLECTIONS: 'page_collections',
  PAGE_USER_TASKS: 'page_user_tasks',

  BASE_UI: 'base_ui',
  ERRORS: 'errors',
  NETWORK: 'network',
  HOTKEYS: 'hotkeys',

  DIFFUSION_MODEL: 'diffusion_model',
  USER_TASK: 'user_task',
  GENERATION: 'generation',
  IMAGE: 'image',
  GRID2D: 'grid2d',
};
